// ─────────────────────────────────────────────────────────────────────────────
// Mack design tokens — SAMPLED from the design references, not chosen.
// Shared by every Mack tab. Extracted from MackPage.tsx in build-04; the values
// are byte-identical to what build-01 established and build-02/03 inherited.
//
// Owner ruling (build-02): inherit these across every remaining tab. Do NOT
// re-sample base colours per image — cross-tab consistency beats a two-level
// per-image difference.
// ─────────────────────────────────────────────────────────────────────────────

// ── COLOUR TOKENS — SAMPLED FROM THE DESIGN ──────────────────────────────────
// Mack's house is WARM. The OS baseline (TradingPage.tsx:19-41) is a cool dark
// (bg #0f0f12 / card #16161a / accent #7F77DD purple); the design gives Mack a
// warm near-black base and an amber/gold accent throughout. Per CLAUDE.md §2
// ("per-agent accents layer on top") Mack's accent is amber — but the design
// also warms the BASE surfaces, which is a deliberate divergence from the shared
// tokens, not drift. Every value below is an eyedropper reading from the PNG.
//
// If the OS baseline is ever meant to win over the per-agent surface, this block
// is the single place to change and the report flags it as an owner decision.
export const C = {
  bg:          '#0a0705',   // page background — warm near-black
  card:        '#100d0b',   // panel surface
  cardBorder:  '#2c1e11',   // warm amber-brown panel edge
  rule:        '#1e1a18',   // row / table separators
  armedRow:    '#1a1110',   // row tint when an alert is armed

  text:        '#ece4dc',   // primary — warm off-white
  textSub:     '#a99a8c',   // secondary
  textMuted:   '#7d7066',   // tertiary / at-floor values

  amber:       '#e8963c',   // PRIMARY ACCENT — titles, imminent countdowns, formula
  amberBright: '#f5b25e',   // armed bell glyph, active chip text
  amberDim:    '#a36d38',   // tab step numerals
  chipBg:      '#322313',   // active filter chip fill
  chipBorder:  '#dea155',   // active filter chip edge
  chipOffBg:   '#161311',   // inactive filter chip fill
  chipOffBd:   '#2a221c',   // inactive filter chip edge

  red:         '#e0605c',   // high impact · ARMED · alert badge/pill
  amberState:  '#e4943b',   // medium impact · WATCH
  blue:        '#6b9fd4',   // HELD · CONFIG · push pill
  blueDim:     '#4c6782',   // CONFIG badge edge
  violet:      '#9986cd',   // wake-tag ink
  violetBd:    '#7a6ba0',   // wake-tag edge
  green:       '#5fbf7a',   // activation at ceiling
  // NEW in build-04 (Phases). The first genuinely new colour since build-01 —
  // everything else in every design so far resolved onto an existing token.
  // Carries the timescales callout and the SLOW speed badge.
  teal:        '#4ecdc4',

  formulaBg:   '#1f170f',   // config/formula strip fill
};

export const MONO = 'var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace)';
export const SANS = 'var(--font-sans, system-ui)';
